import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialGroupItemState: Dtos.GroupItem & IRegistrationFormState = {
    id: null,
    groupId: null,
    group: null,
    groupItemTemplateId: null,
    groupItemTemplate: null,
    collectionInstanceId: null,
    collectionInstance: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
    search: "",
    dataEntered: null,
    filesAdded: null,
    version: null
}

export interface IGroupItemReduxFormState {
    id: IFieldState<number>,
    groupId: IFieldState<number>,
    groupItemTemplateId: IFieldState<number>,
    collectionInstanceId: IFieldState<number>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    message: IFieldState<string>,
    openedModals: IFieldState<string[]>,
    version: IFieldState<string>
}
